import { render, staticRenderFns } from "./HeaderKhabib.vue?vue&type=template&id=c7ab0b3e&lang=pug&"
import script from "./HeaderKhabib.vue?vue&type=script&lang=js&"
export * from "./HeaderKhabib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports